'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Roles = undefined;

var _roles = require('./roles');

var _roles2 = _interopRequireDefault(_roles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Roles = _roles2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/roles/lib/index.js
 ** module id = ./node_modules/roles/lib/index.js
 ** module chunks = 0
 **/